import FormTipoCalzatura from "./FormTipoCalzatura";
export default FormTipoCalzatura;
